import "./components/utils/Polyfills";
import "./components/mobileNav";
import "./components/cart-auto-update";
import baguetteBox from "baguettebox.js";

// import Swiper bundle with all modules installed
import Swiper from "swiper/bundle";
// import Swiper styles
import "swiper/swiper-bundle.css";

// init Swiper:
var mySwiper = new Swiper(".swiper-container", {
    loop: true,
    autoplay: {
        delay: 4500,
        disableOnInteraction: false
    },
    // Navigation arrows
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    }
});

// header animation on scroll
let body = document.body;
let lastScrollTop = 0;
window.addEventListener(
    "scroll",
    () => {
        let st = window.pageYOffset || document.documentElement.scrollTop;
        if (st < 10) {
            body.classList.remove("scroll_down");
            body.classList.remove("scroll_up");
        } else {
            if (st > lastScrollTop) {
                body.classList.add("scroll_down");
                body.classList.remove("scroll_up");
            } else {
                body.classList.remove("scroll_down");
                body.classList.add("scroll_up");
            }
            lastScrollTop = st <= 0 ? 0 : st;
        }
    },
    false
);

let cart_form = document.querySelector("form.cart");
if (cart_form) {
    const remove_icon = cart_form.querySelector(".remove-icon");
    const add_icon = cart_form.querySelector(".add-icon");
    const input = cart_form.querySelector("input.qty");

    if (remove_icon) {
        remove_icon.addEventListener("click", event => {
            event.preventDefault();
            let quantity = parseInt(input.value) - 1;
            input.value = Math.max(quantity, input.min);
        });
    }

    if (add_icon) {
        add_icon.addEventListener("click", event => {
            event.preventDefault();
            let quantity = parseInt(input.value) + 1;
            input.value = Math.min(quantity, input.max);
        });
    }
}

// BaguetteBox

baguetteBox.run(".grid-wrapper", {
    animation: "fadeIn",
    captions: true,
    overlayBackgroundColor: "rgba(#f1f1e8,0.9)",
    buttons: "auto", // arrows navigation
    fullScreen: false,
    noScrollbars: false,
    bodyClass: "baguetteBox-open",
    async: false,
    preload: 4
});
